let locked = false
let savedScrollY = 0

export function setBodyScrollLocked (shouldLock) {
  if (typeof document === 'undefined') return
  if (shouldLock && !locked) {
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.width = '100%'
    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'
    locked = true
    return
  }
  if (!shouldLock && locked) {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.width = ''
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
    locked = false
    window.scrollTo(0, savedScrollY)
  }
}

export function resetBodyScrollLock () {
  locked = false
  savedScrollY = 0
  if (typeof document === 'undefined') return
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.width = ''
  document.body.style.overflow = ''
  document.documentElement.style.overflow = ''
}

/** 출금 가능 금액 모달 등에서 남을 수 있는 body 클래스 잠금 해제 */
export function clearBgModalScrollLock () {
  if (typeof document === 'undefined') return
  document.body.classList.remove('bg-modal-scroll-lock')
}
